import React from "react";
import { Modal, Spin } from "antd";

export default function LoadingModal({ isOpen }) {
  return (
    <Modal open={isOpen} closable={false} footer={null} centered>
      <div
        style={{
          margin: "20px 0",
          width: "100%",
          textAlign: "center",
        }}
      >
        <div
          style={{ fontSize: "20px", marginBottom: "10px", color: "#383d3b" }}
        >
          Đang tạo đơn hàng
        </div>
        <Spin />
        <div
          style={{
            margin: "15px 0",
            fontSize: 16,
            color: "#fb7800",
            fontWeight: 500,
            fontStyle: "italic",
          }}
        >
          Quá trình này sẽ mất khoảng vài phút...
        </div>
      </div>
    </Modal>
  );
}
